var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 37,
    viewBox: "0 0 39 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 10C1 5.02944 5.02944 1 10 1H38V36H10C5.02944 36 1 31.9706 1 27V10Z",
    stroke: "#0885C7",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9245 26H16.0708C14.9292 26 14 25.1305 14 24.0623V16.9429C14 15.8748 14.9292 15.0052 16.0708 15.0052H23.9245C25.066 15.0052 25.9953 15.8748 25.9953 16.9429V24.0623C26 25.1305 25.0708 26 23.9245 26ZM16.0708 16.325C15.7123 16.325 15.4151 16.603 15.4151 16.9429V24.0623C15.4151 24.4022 15.7123 24.6759 16.0708 24.6759H23.9245C24.2877 24.6759 24.5802 24.3978 24.5802 24.0623V16.9429C24.5802 16.603 24.283 16.3294 23.9245 16.3294H16.0708V16.325Z",
    fill: "#0885C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5188 15.7512C22.1273 15.7512 21.8113 15.4554 21.8113 15.0891V13.019C21.8113 12.0833 21 11.3241 20 11.3241C19 11.3241 18.1887 12.0833 18.1887 13.019V15.0847C18.1887 15.451 17.8726 15.7468 17.4811 15.7468C17.0896 15.7468 16.7736 15.451 16.7736 15.0847V13.019C16.7736 11.355 18.2217 10 20 10C21.7783 10 23.2264 11.355 23.2264 13.019V15.0847C23.2264 15.451 22.9104 15.7512 22.5188 15.7512Z",
    fill: "#0885C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 18.5892C19.5897 18.5892 19.2548 18.9026 19.2548 19.2866V21.7186C19.2548 22.1026 19.5897 22.416 20 22.416C20.4104 22.416 20.7453 22.1026 20.7453 21.7186V19.2866C20.7453 18.9026 20.4104 18.5892 20 18.5892Z",
    fill: "#0885C7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 16,
    fill: "white",
    transform: "translate(14 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.1f03ab6a2fc8bd1bbcf768d2f874ecbb.svg";
export { ForwardRef as ReactComponent };